
import Vue from "vue";
import _ from "lodash";
import notificationMixin from '../../mixin/notification';
import store from "../../store/shop";
import ShopAPI from '../../common/api/api_shop';
import { TranslateServiceBuilder } from "../../services/Translate/translateServiceBuilder";
import { TableSession } from "@/model/entity/table_session";
import CategoryOptionConfirm from "./CategoryOptionConfirm.vue";
import { toMatchedOrdersPayload } from "./categoryOptionConfirm";

const translate = TranslateServiceBuilder.Instance()._;
const api = new ShopAPI();

export default Vue.component('NotificationCategoryOption', {
  components: {
    CategoryOptionConfirm,
  },
  mixins: [
    notificationMixin,
  ],
  data() {
    return {
        isModalCategoryOption: {} as { [tId: string]: boolean },
        isLoading: false,
        errors: "",
    };
  },
  mounted() {
    api.set_token(store.state.token);
    // ヘッダの無料化判断アイコン経由で開けと要求されていれば開く
    this.tryOpenRequested();
  },
  computed: {
    notificationCategoryOptions() {
      return store.state.notificationCategoryOption;
    },
    openCategoryOptionRequested() {
      return store.state.openCategoryOptionRequested;
    },
  },
  watch: {
    // ヘッダから開け要求が来たら開く
    openCategoryOptionRequested() {
      this.tryOpenRequested();
    },
    // 別ページから home へ遷移した直後は通知データが後から入るため、揃ったら開く
    notificationCategoryOptions() {
      this.tryOpenRequested();
    },
  },
  methods: {
    // ヘッダから開け要求があり、保留中の通知が揃っていれば先頭のテーブルのモーダルを開く
    tryOpenRequested() {
      if (!store.state.openCategoryOptionRequested) {
        return;
      }
      const all = store.state.notificationCategoryOption || {};
      const hasOptions = (id) => {
        const notification = (all as any)[id];
        return (
          notification &&
          notification.categoryOptions &&
          notification.categoryOptions.length > 0
        );
      };
      // 開始ボタンから特定テーブルが指定されていればそれを、無ければ先頭の保留テーブルを開く
      const requestedTId = store.state.openCategoryOptionRequestedTId;
      const tId = requestedTId && hasOptions(requestedTId)
        ? requestedTId
        : Object.keys(all).find(hasOptions);
      // 通知データがまだ来ていない場合はフラグを残し、揃ったときに再試行する
      if (!tId) {
        return;
      }
      this.$set(this.isModalCategoryOption, tId, true);
      store.commit("clearOpenCategoryOptionRequest");
    },
    // ODR-1696: 背景（オーバーレイ）クリックでポップアップを閉じる
    closeCategoryOption(tId) {
        this.$set(this.isModalCategoryOption, tId, false);
    },
    // ODR-1696: ポップアップに表示するテーブル名（席名 or No.）
    tableLabel(tId) {
        if (store.state.shopSetting.has_guide) {
            let seatName = "";
            _.forEach(store.state.tableGroups, function (tableGroup) {
                _.forEach(tableGroup.table_seats, function (table_seat) {
                    if (table_seat.table_sessions.length && table_seat.table_sessions[0].id == tId) {
                        seatName = table_seat.name;
                    }
                });
            });
            return seatName;
        }
        const tableSession = _.find(store.state.tableSessions, (ts) => ts.id == tId) as TableSession|null;
        return tableSession ? "No." + tableSession.no : "";
    },

    startCategoryOption(notificationCategoryOption, tId) {
      let message = "";
      const matchedOrdersData = toMatchedOrdersPayload(notificationCategoryOption.matchedOrders);
      api
        .start_category_option({
            matched_orders: matchedOrdersData,
            category_options: notificationCategoryOption.categoryOptions,
        })
        .then((response) => {
            if (response.data.status !== "success") {
                message =
                response.data.message ||
                translate("hall-0046", "保存に失敗しました。");
                this.showErrorNotification(message);
                this.errors = message;
                return;
            }
            store.commit('removeNotificationCategoryOption', tId);
            this.$set(this.isModalCategoryOption, tId, false);
            store.dispatch("fetchTableSessions");
            this.isLoading = false;
        })
        .catch((err) => {
            message =
                err.response.data.message ||
                translate("hall-0046", "保存に失敗しました。");
            this.showErrorNotification(message);
            this.errors = message;
            this.isLoading = false;
        });
    },
  },
});
